// ** Icons Import
import { Circle, DollarSign, Edit2, FileText, Users } from "react-feather";
import { ADMIN_ROUTES } from "../../constant/route";

export default [
  {
    header: "Uncut Gems admin",
    role: "admin",
  },
  {
    id: "projectmanagement",
    title: "Project Management",
    icon: <FileText size={20} />,
    navLink: ADMIN_ROUTES.PROJECT_MANAGEMENT,
    role: "admin",
  },
  {
    id: "clientmanagement",
    title: "Client Management",
    icon: <Users size={20} />,
    navLink: ADMIN_ROUTES.CLIENT_MANAGEMENT,
    role: "admin",
  },
  {
    id: "DiscountCoupon",
    title: "Discount Coupon",
    icon: <DollarSign size={20} />,
    navLink: ADMIN_ROUTES.DISCOUNT_COUPON,
    role: "admin",
  },
  {
    id: "ArchivedProjects",
    title: "All Archived Projects",
    icon: <FileText size={20} />,
    navLink: ADMIN_ROUTES.ARCHIVED_PROJECTS,
    role: "admin",
  },
  {
    id: "EditorsMaster",
    title: "Editors Master",
    icon: <Edit2 size={20} />,
    navLink: ADMIN_ROUTES.EDITORS_MASTER,
    role: "admin",
  },
  // {
  //   id: "PopUpMessage",
  //   title: "Pop-Up Message",
  //   icon: <Edit2 size={20} />,
  //   navLink: ADMIN_ROUTES.POPUP_MAGEMENT,
  //   role: "admin",
  // },
  {
    id: "PopUpMessage",
    title: "Edit Pop-Up",
    icon: <Edit2 size={20} />,
    role: "admin",
    children: [
      {
        id: "PopUpMessage1",
        title: "New project",
        icon: <Circle size={12} />,
        role: "admin",
        // navLink: "/apps/roles",
        navLink: `${ADMIN_ROUTES.POPUP_MANAGEMENT_PROJECT}`,
      },
      {
        id: "PopUpMessage2",
        title: "Order Page T&C",
        icon: <Circle size={12} />,
        role: "admin",
        navLink: `${ADMIN_ROUTES.POPUP_MANAGEMENT_ORDER}`,
      },
      {
        id: "PopUpMessage3",
        title: "Subscription T&C",
        icon: <Circle size={12} />,
        role: "admin",
        navLink: `${ADMIN_ROUTES.POPUP_MANAGEMENT_SUBSCRIPTION}`,
      },
    ],
  },
];
